import { EXCEPTIONS_AND_OPPORTUNITY as EXCEPTIONS_AND_OPPORTUNITY_FIELD } from "./";
import { ALL } from "../strings";

const OPTIONS = {
  0: { label: ALL },
  1: {
    label: "Service",
    functionParameters: { type: "serviceExceptions" },
  },
  2: {
    label: "Duty",
    functionParameters: { type: "dutyExceptions" },
  },
  3: {
    label: "Opportunity",
    functionParameters: { type: "opportunityTime" },
  },
};

export const EXCEPTIONS_AND_OPPORTUNITY = {
  title: "Exceptions and Opportunity",
  field: EXCEPTIONS_AND_OPPORTUNITY_FIELD,
  values: Object.keys(OPTIONS).map((option) => ({
    value: option,
    ...OPTIONS[option],
  })),
  filterCallback: ({ route, type }) => route.routeOptimisation?.[type] > 0,
  volumeOverlayRequired: true,
};
